import type {Mailbox} from "./types.ts";

// sync-start:e2e-window-data 780989794 services/static/dev/cypress/e2e/support/wait-for-signal-from-webapp.ts
export const E2E_DATA_PROP = "__ka-e2e__";
// sync-end:e2e-window-data

interface E2EIntegration {
    postMessage: (message: string) => void;
}

/**
 * A mailbox for sending messages during E2E testing.
 */
export class E2EMailbox implements Mailbox {
    private _getE2EIntegration(): E2EIntegration | void {
        if (typeof window === "undefined" || !(E2E_DATA_PROP in window)) {
            return;
        }

        return window[E2E_DATA_PROP] as E2EIntegration;
    }

    /**
     * Send a message to this mailbox.
     *
     * @param message The message to send.
     */
    send(message: string): void {
        this._getE2EIntegration()?.postMessage?.(message);
    }

    /**
     * Is this mailbox available?
     *
     * `true` if this mailbox can be used to send messages; otherwise, `false`.
     */
    get canSend(): boolean {
        // Return true if the E2E tests are ready to receive messages.
        return this._getE2EIntegration() != null;
    }
}
